export default __webpack_public_path__ + "static/1-35c9bc93839ebdf080596bf42c0af048.png";